import api from './api';
import { WhatsAppStatus, WhatsAppGroup } from '../types';

export const whatsappService = {
  async getStatus(): Promise<WhatsAppStatus> {
    const response = await api.get('/whatsapp/status');
    return response.data;
  },

  async initialize(): Promise<{ message: string }> {
    const response = await api.post('/whatsapp/initialize');
    return response.data;
  },

  async disconnect(): Promise<{ message: string }> {
    const response = await api.post('/whatsapp/disconnect');
    return response.data;
  },

  async restart(): Promise<{ message: string }> {
    const response = await api.post('/whatsapp/restart');
    return response.data;
  },

  async getQRCode(): Promise<{ qrCode: string }> {
    const response = await api.get('/whatsapp/qr');
    return response.data;
  },

  async sendTestMessage(number: string, message: string): Promise<{ message: string; result: any }> {
    const response = await api.post('/whatsapp/send-test', { number, message });
    return response.data;
  },

  async getSessionInfo(): Promise<any> {
    const response = await api.get('/whatsapp/session');
    return response.data;
  },

  async getGroups(): Promise<WhatsAppGroup[]> {
    const response = await api.get('/whatsapp/groups');
    return response.data.groups || [];
  }
};
